import type { ReactNode } from "react";
import { useReducedMotion } from "framer-motion";
import { cn } from "@/lib/utils";

type Props = {
  children: ReactNode;
  className?: string;
  color?: string;
  radius?: number;
};

/**
 * Previously rendered a cursor-following radial glow on dark sections.
 * Disabled per design feedback — now a transparent passthrough wrapper
 * so existing usages remain valid.
 *
 * When the user prefers reduced motion, the wrapper is removed entirely
 * to keep the experience calm (WCAG 2.2.2).
 */
const CursorSpotlight = ({ children, className }: Props) => {
  const shouldReduceMotion = useReducedMotion();

  if (shouldReduceMotion) {
    return <>{children}</>;
  }

  return <div className={cn("relative", className)}>{children}</div>;
};

export default CursorSpotlight;
